'use strict';

ServiceRequestParamsPreprocessorFactory.$inject = ['mx.shell.SearchProviderService', 'mx.SolutionBuilderAgent.BasePreprocessor'];

export default function ServiceRequestParamsPreprocessorFactory(searchService, BasePreprocessor) {
	function ServiceRequestParamsPreprocessor() {
		BasePreprocessor.apply(this);
		this.dataModelHelper = new mx.SolutionBuilderAgent.DataModelHelper();
		this.type = mx.SolutionBuilderAgent.PreprocessorType.ServiceRequestParams;
		return this;
	}

	ServiceRequestParamsPreprocessor.prototype = angular.extend(Object.create(BasePreprocessor.prototype), {
		build: function (_parameters) {
			const serviceUrl = this.executor.getServiceUrl();
			const dataModel = _parameters.dataModel || {};
			const dataQuery = _parameters.dataQuery || {};
			const dataQueryModel = dataModel[dataQuery.Name] || dataModel.DataQuery || {};

			searchService.currentSearch().searchForm.conditions.forEach((condition) => {
				if (dataQueryModel.hasOwnProperty(condition.property)) {
					dataQueryModel[condition.property] = condition.value;
				}
			});

			this.executor.setUrlCfg(
				this.dataModelHelper.preparePath(serviceUrl, dataQueryModel, null, {
					useQueryObject: false,
					skipEmptyParameters: true,
				})
			);
		},
	});

	return ServiceRequestParamsPreprocessor;
}
